import { createEngineerNowClient, type EngineerNowClient } from "@engineernow/convex-client/react";
import { API_URL, CONVEX_URL } from "./env";

// Один клиент Convex и одна сессия админа на вкладку (продление — /admin/auth/refresh).
let client: EngineerNowClient | null = null;

export function getEngineerNowClient(): EngineerNowClient {
  if (!client) client = createEngineerNowClient({ convexUrl: CONVEX_URL, apiUrl: API_URL, refreshPath: "/admin/auth/refresh" });
  return client;
}

// Вошёл админ: есть refresh-cookie (как раньше) и access-токен, если он есть, выдан админу.
export function isAdminSession(): boolean {
  const cookies = document.cookie.split("; ");
  const read = (name: string) => cookies.find((row) => row.startsWith(`${name}=`))?.slice(name.length + 1);
  if (!read("token.refresh")) return false;
  const access = read("token.access");
  if (!access) return true;
  try {
    const payload = JSON.parse(atob(decodeURIComponent(access).split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.role === "admin";
  } catch {
    return false;
  }
}
